export default ({ children }: any) => {
  return <h5 className="title m-0">{children}</h5>
}
